export const edsToCodeFormat = (word?: string) => {
  if (!word || typeof word !== 'string') return word as string;

  // Replace all first upper cased letters with lower case, except the last letter
  // e.g. OTPChannelId -> otpChannelId
  return word.replace(/^[A-Z]+/, (match) =>
    match.length > 1 ? match.slice(0, -1).toLowerCase() + match.at(-1) : match.toLowerCase(),
  );
};

export const edsToEntityFormat = (word: string) => {
  if (!word || typeof word !== 'string') return word;

  return `${word[0].toUpperCase()}${word.slice(1)}`;
};
